<template>
  <div style="position: relative">
    <div>
      <div class="warperr clearfix">
        <div class="picture">
          <left-image v-if="detailImageList.length" :imageList="detailImageList" />
        </div>
        <div class="price-config-box">
          <div style="margin-left: 0px">
            <h3>{{ productName }}</h3>
            <div class="price">
              <div>
                <span style=" color: #828080; font-size: 16px; padding-left: 30px; ">价格</span>
                <span style="color: #ff9000; padding-left: 15px">
                  ¥
                  <strong style="font-size: 25px">{{ productUnitPrice }}</strong>
                </span>
                <span style="color: #828080; font-size: 16px; padding-left: 30px; ">标配价</span>
                <span style="color: #ff9000; padding-left: 15px">
                  ¥
                  <strong style="font-size: 25px">{{ defaultPrice }}</strong>
                </span>
                <span style="color: #828080; font-size: 16px; padding-left: 30px; ">起购数：</span>
                <strong style=" color: #ff9000; padding-left: -5px; font-size: 23px; ">{{ minPurchaseQty }}</strong>
              </div>
            </div>
            <div class="productConfig" v-for="(config, index) in productConfigList" :key="index">
              <dl>
                <dt>{{ config.configName }}</dt>
                <dd v-for="option in config.options" :key="option.optionCode" @click="clickOption(index, option)" :class="[option.class, option.defaultFlag ? 'fontBold' : '' ]">
                  {{ option.optionName }}
                </dd>
              </dl>
            </div>
            <div class="quantity">
              <span style="margin-right: 30px">数量</span>
              <input type="number" v-model="quantity" min="1" max="99999" @input="onIput" />
            </div>
            <div class="aging">
              <div class="agingItem">
                <p>分期购</p>
                <p>首付&nbsp;<span>¥{{Number(downPayment).toFixed(2)}}</span></p>
                <template v-if="installIndex !== '' && !isNaN(installIndex)">
                  <p style="margin-left: 20px">月供&nbsp;<span>¥{{balancePayment[installIndex].paymentPerPeriod}}</span></p>
                  <p style="margin-left: 20px">总金额&nbsp;<span>¥{{Number(downPayment + balancePayment[installIndex].paymentPerPeriod * balancePayment[installIndex].installmentNumber).toFixed(2) }}</span></p>
                </template>
              </div>
              <dl>
                <dt></dt>
                <dd v-for="(balance, index) in balancePayment" :key="index" :class="installIndex === index ? 'asingActive':''" @click="onAsingActive(index)">
                  <div>{{balance.installmentNumber}} 期</div>
                  <p>(<strong>{{Number(installmentRate).toPercent()}}</strong>手续费)</p>
                </dd>
              </dl>
            </div>

            <div style="margin-top: 20px">
              <Button type="warning" size="large" style="width: 140px" @click="addToShoppingCart">
                <Icon type="ios-cart" style="margin-right: 5px" />加入购物车
              </Button>
              <Button type="error" size="large" style="margin-left: 40px; width: 140px" @click="buyNow">立即购买</Button>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <!-- 相似托盘 -->
          <product :productList="recommandProductList" />
        </div>
        <div class="right">
          <!-- tab切换 -->
          <tabs @onActive="onActive" :tabList="tabList" :tabsTop="741" width="813px" />
        
            <!-- 产品规格 -->
            <div class="productSpec" v-show="active === 'productSpec'">
              <product-spec :targetModelCode="targetModelCode" :descImageList="descImageList" />
            </div>
            <!-- 售后保障 -->
            <div v-show="active === 'after-sale'">
              <after-sale />
            </div>
            <div v-show="active === 'consult'">
              <consult />
            </div>
        </div>
      </div>
    </div>
    <qrcode-product :qrCode="qrCode" />
    <my-spin :spinShow="spinShow" />
  </div>
</template>

<script>
import leftImage from "./left-image.vue";
// import productDesc from './product-desc';
import tabs from "./component/tabs";
import productSpec from "./component/productSpec";
import afterSale from "./component/after-sale";
import consult from "./component/consult";
import product from "./component/product";

import mySpin from "_c/app-component/mySpin.vue";
import qrcodeProduct from "_c/app-component/qrcode-product"; //商品二维码
export default {
  name: "mallDetail",
  components: {
    leftImage,
    tabs,
    productSpec,
    afterSale,
    consult,
    product,
    mySpin,
    qrcodeProduct,
  },
  data() {
    return {
      spinShow: true,
      active: "productSpec",
      productConfigList: [],
      minPurchaseQty: 0,
      productUnitPrice: 0,
      defaultPrice: 0,
      productId: "",
      productName: "",
      quantity: 1,
      config: {},
      detailImageList: [],
      descImageList: [],
      qrCode: {},
      faceImage: "",
      targetModelCode: "",
      tabList: [
        { title: "产品规格", desc: "productSpec" },
        { title: "售后保障", desc: "after-sale" },
        { title: "购买咨询", desc: "consult" },
      ],
      recommandProductList: [],
      configuredTargets: [],
      // configId: [available option list], 因为有些配置了option没有关联标的物
      availOptions: {},
      downPayment: '',
      balancePayment: [],
      installmentRate: '',
      installIndex: '',
    };
  },
  watch: {
    $route(to, from) {
      this.productId = this.$route.query.productId;
      if (!this.productId) return;

      this.getConfigList();
      this.queryRecommandProductList();
    },
    productId: function (newVal, oldVal) {
      if (newVal) this.productUnitPrice = 0;
    },
  },

  mounted() {
    this.productId = this.$route.query.productId;
    this.getConfigList();
    this.queryRecommandProductList();
  },
  methods: {
    onAsingActive(index) {
      this.installIndex = index;
    },
    onIput() {
      if (this.quantity.length > 5) {
        this.quantity = this.quantity.slice(0, 5);
      }
    },
    // 点击tab回调
    onActive(index) {
      this.active = index;
    },
    getConfigList() {
      let data = {
        url: "http://MID-CLIENT-MALL/messageService/shelfService/queryProductDetail",
        body: { productId: this.productId },
      };

      let p1 = this.invoke(data);

      let param = {
        url: "http://MID-CLIENT-MALL/messageService/productConfigService/queryProductTargetByProductId",
        body: { productId: this.productId },
      };

      let p2 = this.invoke(param);

      Promise.all([p1, p2]).then(([rs, productTargets]) => {
        this.initPageParameter(rs);
        this.initConfigOption(productTargets);
        this.spinShow = false;

        let config = {};
        this.productConfigList.map(({ productConfigId, options }) => {
          config[productConfigId] = options.find(({ defaultFlag }) => defaultFlag == 'Y').optionCode;
        });

        this.queryInstallmentParameter(config);
      });
    },

    initPageParameter(rs) {
      ({
        productConfigList: this.productConfigList,
        minPurchaseQty: this.minPurchaseQty,
        productName: this.productName,
        productId: this.productId,
        defaultPrice: this.defaultPrice,
        detailImageList: this.detailImageList,
        descImageList: this.descImageList,
        faceImage: this.faceImage,
        targetModelCode: this.targetModelCode,
      } = rs);

      this.quantity = rs.minPurchaseQty;
      if (rs.qrCode) this.qrCode = rs.qrCode;
    },
    initConfigOption(productTargets) {
      this.configuredTargets = productTargets;
      let availOptions = {};
      productTargets.forEach(({ config }) => {
        for (let key in config) {
          availOptions[key] ||= [];
          availOptions[key].push(config[key]);
        }
      });
      // 保存在全局变量
      this.availOptions = availOptions;

      this.productConfigList.forEach(({ options, configType }) => {
        if (configType == "target")
          options.forEach((option) => {
            if (!availOptions[option.productConfigId]?.includes(option.optionCode)) {
              option.class = "disabled";
            }
          });
      });
    },
    queryRecommandProductList() {
      let data = {
        url: "http://MID-CLIENT-MALL/messageService/shelfService/queryRecommendProductList",
        body: { productId: this.productId },
      };
      this.invoke(data).then((list) => {
        this.recommandProductList = list.filter((item) =>
          item.productId != this.productId && item.productType == "sale"
        );
      });
    },
    getProductUnitPrice() {
      let config = {};

      this.productConfigList.map(({ options }) => {
        let option = options.find(({ checked }) => checked);
        if (option) config[option.productConfigId] = option.optionCode;
      });

      // this.config = config;
      // 属性都选了, 那么动态查询销售价格
      if (this.productConfigList.length != Object.entries(config).length)
        return;

      let data = {
        url: "http://MID-CLIENT-MALL/messageService/shelfService/calculateModelPriceWithConfig",
        body: { productId: this.productId, config },
      };

      this.invoke(data).then(({ salePrice }) => {
        this.productUnitPrice = salePrice;
      });

      this.queryInstallmentParameter(config);
    },
    clickOption(configIndex, option) {
      // class: 选中[checked] 未选中[uncheck] 不可选[disabled]
      let thisConfig = this.productConfigList[configIndex];

      if (thisConfig.configType == 'target') {
        this.onCheckTargetConfig(configIndex, option);
      } else {

        if (option.checked) {
          option.checked = false;
          option.class = 'uncheck';
        } else {
          thisConfig.options.forEach(item => {
            item.checked = item.optionCode == option.optionCode;
            item.class = item.checked ? 'checked' : 'uncheck';
          })
        }
      }

      this.$forceUpdate();
      this.getProductUnitPrice();
    },
    onCheckTargetConfig(configIndex, option) {
      // 点击 class == 'disabled'; return
      // 点击 checked(true) => checked(false)
      // 点击 checked(false) => checked(true), 其它项变为 checked(false)

      if (option.class == "disabled") return;

      if (option.checked) {
        option.checked = false;
      } else {
        this.productConfigList[configIndex].options.forEach(item => {
          item.checked = item.optionCode == option.optionCode;
        })
      }
      // 可以找出不完整的配置表
      // 查出每行的可选项
      // 循环每行设置class, 
      //  checked(true) => class(checked)
      //  其它, 可选 => class(uncheck); 不可选 => class(disabled);

      let configMap = {}; // 目前的选配
      this.productConfigList.forEach((_config, _index) => {
        if (_config.configType != 'target') return;

        _config.options.forEach(_option => {
          if (_option.checked)
            configMap[_config.productConfigId] = _option.optionCode;
        })
      });

      this.productConfigList.forEach((config, index) => {

        if (config.configType != 'target') return;

        let opts = [];
        // 根据不完整配置找出本行的可选项
        if (Object.keys(configMap).length) {
          this.configuredTargets.forEach((productTarget) => {
            let match = true;
            for (let key in configMap) {
              // 需要匹配除本行以外的配置
              if (key == config.productConfigId) continue;
              if (productTarget.config[key] != configMap[key]) {
                match = false;
              }
            }
            if (match)
              opts.push(productTarget.config[config.productConfigId]);
          })
        } else {
          // configMap 是空的时候, 要到完整的配置去查
          opts = this.availOptions[config.productConfigId];
        }

        config.options.forEach(item => {
          if (item.checked) {
            item.class = 'checked';
          } else {
            item.class = opts.includes(item.optionCode) ? 'uncheck' : 'disabled';
          }
        })
      })
    },
    async buyNow() {
      let product = this.checkProductBeforeShopping();

      if (this.minPurchaseQty > this.quantity)
        this.errorPrompt("最小购买数量为:" + this.minPurchaseQty);

      let sessionId = this.pltSession.getSession()
      if (!sessionId) {
        await this.showConfirm("提示", "您还未登陆, 去登陆?");
        this.$router.push("/login");
        this.$store.commit("anonymous/setPath", {
          query: { productList: JSON.stringify([product]) },
          to: "/confirm-order",
        });
        return;
      }

      this.$router.push({
        path: "/confirm-order",
        query: { productList: JSON.stringify([product]) },
      });
    },
    async addToShoppingCart() {
      let sessionId = this.pltSession.getSession()
      if (!sessionId) {
        await this.showConfirm("提示", "您还未登陆, 去登陆?");
        this.$router.push("/login");
        return;
      }

      let product = this.checkProductBeforeShopping();
      let { productId, quantity, config } = product;

      let productConfig = config.map(({ productConfigId, optionCode }) => {
        return { productConfigId, optionCode };
      }
      );

      let param = { productId, quantity, config: productConfig };

      let data = {
        url: "http://MID-CLIENT-MALL/messageService/shoppingCartService/addToShoppingCart",
        body: { shoppingCart: param },
      };

      this.invoke(data).then(() => {
        this.$Message.success("已成功添加到购物车!");
      });
    },
    checkProductBeforeShopping() {
      if (
        this.productConfigList.length >
        Object.entries(this.config).length
      )
        this.errorPrompt("请选择商品配置");

      let config = this.productConfigList.map(
        ({ configName, options }) => {
          let {
            optionName,
            optionCode,
            productConfigId,
          } = options.find(({ checked }) => checked);
          return {
            configName,
            optionName,
            optionCode,
            productConfigId,
          };
        }
      );

      // 商品名称, 商品ID, 购买数量, 配置表, 单价
      return {
        productId: this.productId,
        productName: this.productName,
        quantity: this.quantity,
        productUnitPrice: this.productUnitPrice,
        minPurchaseQty: this.minPurchaseQty,
        faceImage: this.faceImage,
        config,
      };
    },
    queryInstallmentParameter(config) {

      let param = {
        url: 'http://MID-CLIENT-MALL/messageService/productService/queryInstallmentParameter',
        body: {
          productId: this.productId, config
        }
      }

      this.invoke(param).then(rs => {
        this.balancePayment = rs.balancePayment;
        this.downPayment = rs.down_payment;
        this.installmentRate = rs.installment_rate;
      });

    }
  },
};
</script>

<style lang="scss" scoped>
@mixin clear {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
@mixin triangle {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  border-left: solid 8px transparent;
  border-bottom: solid 8px #ff9000;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.warperr {
  margin: 20px 0 20px 0;
}
.picture {
  margin-right: 18px;
  float: left;
}

.price-config-box {
  float: right;
  h3 {
    margin: 6px 0 15px 0;
  }
  .price {
    width: 625px;
    height: 45px;
    background: #ecebeb;
    // line-height: 55px;
    margin-bottom: 20px;
    div:nth-child(2) {
      margin-left: 30px;
      color: #828080;
    }
  }
  .productConfig {
    display: flex;
    align-items: center;
    dl {
      display: flex;
      margin-top: 10px;
      align-items: center;
    }
    dt {
      width: 70px;
    }
    .fontBold {
      font-weight: bold;
    }

    dd {
      width: 70px;
      cursor: pointer;
      padding: 5px 0px;
      border: 1px solid #b8b7bd;
      text-align: center;
      margin-right: 10px;
      position: relative;
      border-radius: 3px;
      @include clear;
    }
    .checked {
      border-color: #ff9000;
      color: #ff9000;
      font-weight: bold;
      &:hover {
        cursor: pointer;
        border-color: #ff9000;
      }
      &:before {
        @include triangle;
      }
    }
    .disabled {
      background-color: #bbbec4;
      &:hover {
        cursor: not-allowed;
      }
    }
    .uncheck {
      &:hover {
        cursor: pointer;
        border-color: #ff9000;
      }
    }
  }
  .quantity {
    margin-top: 20px;
    input {
      margin-left: 11px;
      width: 152px;
      height: 30px;
      outline: none;
      border: 1px solid #ff9000;
      padding-left: 10px;
      border-radius: 3px;
    }
  }
  // 分期购
  .aging {
    .agingItem {
      display: flex;
      margin-top: 10px;
      p:first-child {
        margin-top: 5px;
        width: 70px;
      }
      p {
        span {
          color: #ff9000;
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
    dl {
      display: flex;
      margin-top: 10px;
      align-items: center;
    }
    dt {
      width: 70px;
    }
    .fontBold {
      font-weight: bold;
    }

    dd {
      cursor: pointer;
      padding: 5px 10px;
      border: 1px solid #b8b7bd;
      text-align: center;
      margin-right: 10px;
      border-radius: 3px;
      box-sizing: border-box;
      @include clear;
      &:hover {
        border-color: #ff9000;
      }
    }
    .asingActive {
      border-color: #ff9000;
      position: relative;
      &:before {
        @include triangle;
      }
    }
  }
}
// 商品介绍
.content {
  width: 100%;
  .left {
    width: 260px;
    float: left;
    margin-left: 5px;
  }
  .right {
    width: 813px;
    float: left;
    // width: 800px;
  }
}
</style>